module.exports = __webpack_public_path__ + "static/img/1_0038.3189e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0038.jpg
// module id = 9ftw
// module chunks = 0